export function generatedBy(name: string, date: string): string {
  return `Generated ${new Date(date).toLocaleString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  })} by ${name}.`;
}
